var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequestRemoteAccessUserIcon = function SvgRequestRemoteAccessUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 14.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M6 16.75c-1.571 0-2.944.933-3.682 2.321-.303.57.175 1.179.82 1.179h5.726c.644 0 1.122-.61.82-1.179C8.946 17.683 7.573 16.75 6 16.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M6 14.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM6 16.75c-1.571 0-2.944.933-3.682 2.321-.303.57.175 1.179.82 1.179h5.726c.644 0 1.122-.61.82-1.179C8.946 17.683 7.573 16.75 6 16.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3 7.5v-1a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"
  })));
};
export { SvgRequestRemoteAccessUserIcon as ReactComponent };
export default __webpack_public_path__ + "bf60a53112e0ae5de849d34777d59819.svg";